<template>
    <div id="contenedor-estimaciones-listado-mobiles">
      <template
        v-for="estimacion in estimaciones">
        <v-card
          :key="estimacion.id"
          class="mb-3 mt-1"
          flat>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="6">
                Número:
              </v-col>
              <v-col cols="6" class="text-right mb-2">
                <v-chip
                  small>
                  {{ estimacion.numero }}
                </v-chip>
              </v-col>
              <v-col cols="12">
                Fecha Del: <v-chip small class="font-weight-bold">
                  {{ new Date(`${estimacion.fechaDel}T00:00:00`)
                .toLocaleDateString() }}
                </v-chip>
                Fecha Al: <v-chip small class="font-weight-bold">
                  {{ new Date(`${estimacion.fechaAl}T00:00:00`).toLocaleDateString() }}
                </v-chip>
              </v-col>
              <v-col cols="6">
                Estimado:
              </v-col>
              <v-col cols="6" class="text-right mb-2">
                <v-chip
                  small>
                  {{ estimacion.importeEstimado | currency }}
                </v-chip>
              </v-col>
              <v-col cols="6">
                Amortización Ant.
              </v-col>
              <v-col cols="6" class="text-right mb-2">
                <v-chip small>
                  {{ estimacion.importeAmortizacionAnticipo | currency }}
                </v-chip>
              </v-col>
              <v-col cols="6">
                IVA
              </v-col>
              <v-col cols="6" class="text-right mb-2">
                <v-chip
                  small>
                  {{ estimacion.importeIva | currency }}
                </v-chip>
              </v-col>
              <v-col cols="6">
                Facturado
              </v-col>
              <v-col cols="6" class="text-right mb-2">
                <v-chip
                  small
                  class="font-weight-bold">
                  {{ estimacion.totalFactura | currency }}
                </v-chip>
              </v-col>
              <v-col cols="12">
                <v-divider class="mb-2"></v-divider>
              </v-col>
              <v-col cols="6">
                Deducciones
              </v-col>
              <v-col cols="6" class="text-right mb-2">
                <v-chip
                  small>
                  {{ estimacion.importeDeducciones | currency }}
                </v-chip>
              </v-col>
              <v-col cols="6">
                Retenido
              </v-col>
              <v-col cols="6" class="text-right mb-2">
                <v-chip
                  color="warning"
                  small
                  :disabled="estimacion.importeRetenido <= 0">
                  {{ estimacion.importeRetenido | currency }}
                </v-chip>
              </v-col>
              <v-col cols="6">
                Devuelto
              </v-col>
              <v-col cols="6" class="text-right mb-2">
                <v-chip
                  color="success"
                  small
                  :disabled="estimacion.importeDevuelto <= 0">
                  {{ estimacion.importeDevuelto | currency }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </div>
</template>

<script>
export default {
  name: 'EstimacionesListadoMobiles',
  props: {
    estimaciones: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
